module.exports = __webpack_public_path__ + "static/img/1809_1.724cae4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1809_1.jpg
// module id = xnaf
// module chunks = 1